<div class="myPurchase-dialog-container">
    <div class="myPurchase-dialog-header">
        Select EXCO/Board/AOR approval document </div>
    <p>If you have a pre-approved AOR to be added into this list, please contact Finance
        (Budget & Control team)</p>
    <div class="myPurchase-dialog-content">
        <app-selectable-table [data]="excoBoardDocumentArray" [columns]="excoBoardColumns" [selection]="selectedData"
            [totalCount]="totalRecords" (pageDetailsHandler)="handlePageEvent($event)"
            (searchHandler)="handleSearchEvent($event)"></app-selectable-table>
        <div style="padding-top:20px">
            <shared-alert [type]="alertType.Error" *ngIf="duplicateFound">
                <p alert-content class="my-1">Duplicate entry detected. Please remove the duplicate and try again.</p>
            </shared-alert>
        </div>
    </div>
    <div class="myPurchase-dialog-actions">
        <div mat-dialog-actions>
            <app-button class="padBtn" name="Close" mat-dialog-close></app-button>
            <app-button class="padBtn actionBtn" type="flat-button" name="Submit" (click)="onSubmit()"></app-button>
        </div>
    </div>
</div>